<template>
    <div>
<div class="mb-3">
        <h3 class="mb-2">{{ product.name }}</h3>

        <div>
            <rating class="pull-left m-r-10 " :rate="product.stats.rate"></rating>
            <b><span v-if="product.stats.rate" style="margin-left: 8px;">{{ product.stats.rate }} out of 5 |</span> {{ product.stats.reviews }}
            review{{ product.stats.reviews > 1 ? 's' : '' }} | {{ product.stats.users }} user{{ product.stats.users
            > 1 ?
            's' : '' }}</b>
        </div>
        <hr>
</div>
        <div class="row">
            <div class="col-lg-12" v-for="(review, index) in product.reviews" :key="index">
                <div>
                    <div class="card-body">
                        <review :item="review"></review>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import _ from "lodash";
import Rating from "@/components/Rating";
import RatingStats from "@/components/RatingStats";
import Review from "@/components/Review";
import VueGallery from "vue-gallery";
import Vue from "vue";
import Vuex from "vuex";
export default {
    name: "Product",
    data() {
        return {
            product: null
        };
    },
    components: {
        gallery: VueGallery,
        rating: Rating,
        review: Review,
        "rating-stats": RatingStats
    },

    created: function () {
        this.fetchData();
    },
    watch: {
        product: function (val) {
            if (this.isAuthenticated) {
                this.checkPurchase();
            }
        }
    },
    mounted() {
        this.fetchNames();
    },
    methods: {
        fetchData: function () {
            let productUri = "product/public/";
            this.$http
                .get(`${productUri}${this.$route.params.slug}`, {
                    params: { populate: "author" }
                })
                .then(
                    response => {
                        this.product = response.body;
                        this.product.reviews = this.product.reviews || [];
                    },
                    response => {
                        // error callback
                        console.log(response);
                    }
                );
        },
    }
};
</script>
<style>
.account-container .account-body {
    margin-left: 300px;
    padding: 20px 30px;
}

h3 {
    font-size: 24px;
}

.h1,
.h2,
.h3,
h1,
h2,
h3 {
    margin-top: 20px;
    margin-bottom: 10px;
}

.row:before {
    display: table;
    content: " ";
}


@media (min-width: 1200px) {
    .col-lg-4 {
        width: 33.33333333%;
    }
}

.widget.widget-stats {
    position: relative;
}

.widget {
    color: #fff;
    padding: 15px;
    overflow: hidden;
    border-radius: 3px;
    margin-bottom: 20px;
}

.bg-gradient-green {
    background: linear-gradient(135deg, #34babb, #00acac) !important;
}

.row:after {
    clear: both;
}
</style>


// WEBPACK FOOTER //
// src/admin/views/DashboardReviewAdmin.vue